(() => {
  const desktop = window.matchMedia('(min-width: 1200px)');
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  function init(root = document) {
    root.querySelectorAll('[data-it-header]:not([data-it-ready])').forEach(header => {
      header.dataset.itReady = 'true';
      const locale = header.querySelector('.it-header__locale-space');
      document.querySelectorAll('.t4s-btn-languages-sidebar, .t4s-btn-currencies-sidebar').forEach(button => locale.append(button));
      const menus = [...header.querySelectorAll('[data-it-mega]')];
      const dialog = header.querySelector('dialog');
      const trigger = header.querySelector('[data-it-menu-open]');
      const close = header.querySelector('[data-it-menu-close]');
      const closeMenus = except => menus.forEach(menu => { if (menu !== except) menu.open = false; });
      menus.forEach((menu, index) => {
        let timer;
        const summary = menu.querySelector('summary');
        summary.addEventListener('click', event => {
          if (event.detail > 0 && desktop.matches && hover.matches) {
            event.preventDefault();
            closeMenus(menu);
            menu.open = true;
          }
        });
        menu.addEventListener('pointerenter', () => {
          if (!desktop.matches || !hover.matches) return;
          clearTimeout(timer);
          closeMenus(menu);
          menu.open = true;
        });
        menu.addEventListener('pointerleave', () => {
          timer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 180);
        });
        menu.addEventListener('toggle', () => { if (menu.open) closeMenus(menu); });
        menu.addEventListener('focusout', () => requestAnimationFrame(() => {
          if (!menu.contains(document.activeElement)) menu.open = false;
        }));
        menu.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            menu.open = false;
            summary.focus();
            event.preventDefault();
          }
          if (event.target === summary && event.key === 'ArrowDown') {
            menu.open = true;
            closeMenus(menu);
            menu.querySelector('a')?.focus();
            event.preventDefault();
          }
          if (event.target === summary && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            menu.open = false;
            menus[(index + direction + menus.length) % menus.length].querySelector('summary').focus();
            event.preventDefault();
          }
        });
      });
      document.addEventListener('click', event => { if (!header.contains(event.target)) closeMenus(); });
      trigger.addEventListener('click', () => {
        dialog.showModal();
        document.documentElement.classList.add('it-menu-open');
        trigger.setAttribute('aria-expanded', 'true');
        close.focus();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target === dialog || event.target.closest('a')) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('it-menu-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({preventScroll: true});
      });
      const categories = [...dialog.querySelectorAll('[data-it-mobile-category]')];
      categories.forEach(category => category.addEventListener('toggle', () => {
        if (category.open) categories.forEach(other => { if (other !== category) other.open = false; });
      }));
      desktop.addEventListener('change', () => {
        closeMenus();
        if (desktop.matches && dialog.open) dialog.close();
      });
      const labels = {search:'Search', account:'Account', heart:'Wishlist', cart:'Cart'};
      Object.entries(labels).forEach(([key,label]) => {
        header.querySelectorAll(`.t4s-site-nav__${key} > a`).forEach(link => link.setAttribute('aria-label', label));
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.it-header__locale-space > button').forEach(button => document.body.append(button));
  });
})();
